// extracted by mini-css-extract-plugin
export var section = "styles-module--section--VA7iQ";
export var container = "styles-module--container--kWqnB";
export var title = "styles-module--title--z9MlS";
export var cta = "styles-module--cta--X7ZRB";
export var backAndForthRight = "styles-module--backAndForthRight--P7IIA";
export var wobbleRightAndLeft = "styles-module--wobbleRightAndLeft--vHCC8";
export var animateBg = "styles-module--animateBg--UlMZa";